import React, { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { storageApi } from "../lib/api";
import { formatPercentTR } from "../lib/storageFormat";

/** Depolama doluluk şeridi — %80 üstünde sarı, %95 üstünde kırmızı.
 *  Kapatma yalnızca bileşen yaşadığı sürece geçerlidir; sayfa yenilenince
 *  şerit tekrar görünür (kalıcı susturma YOK).
 *  Satır içi akış elemanıdır; hiçbir tıklamayı engellemez. */
export const StorageWarningBanner = ({ onOpenStorage }) => {
  const [usage, setUsage] = useState(null);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    let alive = true;
    storageApi.usage(false).then((u) => { if (alive) setUsage(u); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  const pct = usage?.used_percent || 0;
  if (closed || pct <= 80) return null;

  const critical = pct > 95;
  return (
    <div
      data-testid="storage-warning-banner"
      data-level={critical ? "critical" : "warning"}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-[12px] ${
        critical
          ? "border-rose-500/50 bg-rose-500/10 text-rose-200"
          : "border-amber-400/50 bg-amber-500/10 text-amber-200"
      }`}
    >
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span className="min-w-0">
        {critical
          ? `Dosya alanınızın ${formatPercentTR(pct)}'i doldu. Alan dolmak üzere, yeni dosya yüklenemeyebilir.`
          : `Dosya alanınızın ${formatPercentTR(pct)}'i doldu.`}
      </span>
      <button
        type="button"
        onClick={onOpenStorage}
        data-testid="storage-warning-open"
        className="shrink-0 underline underline-offset-2 hover:opacity-80"
      >
        Depolama ayarlarını aç
      </button>      <button
        type="button"
        onClick={() => setClosed(true)}
        data-testid="storage-warning-close"
        aria-label="Uyarıyı kapat"
        title="Bu oturum için kapat"
        className="ml-auto shrink-0 p-1 rounded hover:bg-white/10"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default StorageWarningBanner;
